import { useTranslation } from 'react-i18next';
import { RankCard } from '@/shared/components/RankCard';
import { RANK_PRESETS } from '@/shared/components/RankCard/rankCardPresets';
import { StatsPill } from '@/shared/components/StatsPill';

interface LeaderboardUserSummaryProps {
  rank: number;
  username: string;
  score: number;
  gamesPlayed: number;
  wins: number;
  losses: number;
}

export function LeaderboardUserSummary({
  rank,
  username,
  score,
  gamesPlayed,
  wins,
  losses
}: LeaderboardUserSummaryProps) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-2">
      <RankCard rank={rank} username={username} score={score} background={RANK_PRESETS.regular} />
      <div className="flex gap-2">
        <StatsPill label={t('leaderboard.gamesPlayed')} value={gamesPlayed} />
        <StatsPill label={t('leaderboard.wins')} value={wins} />
        <StatsPill label={t('leaderboard.losses')} value={losses} />
      </div>
    </div>
  );
}

export default LeaderboardUserSummary;
